module.exports = __webpack_public_path__ + "media/audio7.6e18ba23.mp3";